import { Mark } from 'slate'
import { COLOUR_MARK } from './markTypes'

export default function ColourMark(colour) {
  return Mark.create({
    type: COLOUR_MARK,
    data: { colour }
  })
}
